import {gql} from "@apollo/client";

export default gql`
query($email: String!) {
    adminIsExists(email: $email)
  }
`;
